<template lang="pug">
  ValidationObserver(v-slot="{ invalid, handleSubmit }" ref="validator")
    v-form.px-sm-0.px-md-10.pb-0.pb-sm-2.pb-md-4(@submit.prevent="handleSubmit(submitDataForm)")
      v-row
        v-col(cols="12" sm="6" md="4")
          BaseTextField(v-model="form.key1", :label="translations.label.key1")
        v-col(cols="12" sm="6" md="4")
          BaseTextField(v-model="form.key2", :label="translations.label.key2")
        v-col(cols="12" sm="6" md="4")
          BaseTextField(v-model="form.key3", :label="translations.label.key3")
        v-col(cols="12" sm="6" md="4")
          BaseFloatField(v-model="form.ggr", :label="translations.label.ggr" min="0" max="100" decimals="2")
        v-col(cols="12" sm="6" md="4")
          BaseFloatField(v-model="form.cap", :label="translations.label.cap" min="0" max="100" decimals="2")
      v-row
        v-col(cols="12")
          fieldset.fantasy__fieldset--basic
            legend Urls:
            v-row
              v-col.py-0(cols="12" sm="6" md="4")
                BaseTextField(rules="host" v-model="form.urls.launcher", :label="translations.label.urls.launcher")
              v-col.py-0(cols="12" sm="6" md="4")
                BaseTextField(rules="host" v-model="form.urls.bonusAward", :label="translations.label.urls.bonusAward")
              v-col.py-0(cols="12" sm="6" md="4")
                BaseTextField(rules="host" v-model="form.urls.bonusCancel", :label="translations.label.urls.bonusCancel")
              v-col.py-0(cols="12" sm="6" md="4")
                BaseTextField(rules="host" v-model="form.urls.ping", :label="translations.label.urls.ping")
              v-col.py-0(cols="12" sm="6" md="4")
                BaseTextField(rules="host" v-model="form.urls.roundDetails", :label="translations.label.urls.roundDetails")
              v-col.py-0(cols="12" sm="6" md="4")
                BaseTextField(rules="host" v-model="form.urls.fixedLauncher", :label="translations.label.urls.fixedLauncher")
              v-col.py-0(cols="12" sm="6" md="4")
                BaseTextField(rules="host" v-model="form.urls.baseUrl", :label="translations.label.urls.baseUrl")
              v-col.py-0(cols="12" sm="6" md="4")
                BaseTextField(rules="host" v-model="form.urls.gameList", :label="translations.label.urls.gameList")
      v-row
        v-col(cols="12")
          fieldset.fantasy__fieldset--basic
            legend {{ translations.label.cl.title }}:
            v-row
              v-col.py-0(cols="12" sm="6" md="4")
                v-checkbox.mt-0(v-model="form.cl.f", :label="translations.label.cl.f")
              v-col.py-0(cols="12" sm="6" md="4")
                v-checkbox.mt-0(v-model="form.cl.w", :label="translations.label.cl.w")
      v-row
        v-col(cols="12").py-4
          v-expansion-panels(accordion)
            v-expansion-panel
              v-expansion-panel-header
                p.title.ma-0 {{ translations.label.extrafields }}
              v-expansion-panel-content
                v-divider.mb-4
                BaseDynamicField(v-model="form.params")
      v-row
        v-col(cols="12").py-4
          v-expansion-panels(accordion)
            v-expansion-panel
              v-expansion-panel-header
                p.title.ma-0 {{ translations.label.extrafieldsHidden }}
              v-expansion-panel-content
                v-divider.mb-4
                BaseDynamicField(v-model="form.launcherParams")
      v-row
        v-col(cols="12").mt-5
          v-btn(:disabled="invalid"
            color="primary"
            type="submit"
            :loading="loadingEdit") {{ translations.button.edit }}
</template>

<script>

  export default {
    name: "OperatorProviderEdit",
    props:{
      clearForm: {
        type: Boolean,
        default: false
      },
      translations: {
        type: Object,
        default: function(){
          return {}
        }
      },
      operator:{
        type: String,
        default: ''
      },
      provider:{
        type: Object,
        default: function(){
          return {}
        }
      },
    },
    data:() => ({
      form: {
        key1: '',
        key2: '',
        key3: '',
        ggr: null,
        cap: null,
        urls: {
          launcher: '',
          bonusAward: '',
          bonusCancel: '',
          ping: '',
          roundDetails: '',
          fixedLauncher: '',
          baseUrl: '',
          gameList: '',
        },
        params: [],
        launcherParams: [],
        cl: {
          f: false,
          w: false,
        },
      },
    }),
    computed: {
      loadingEdit() {
        return this.$store.state.statusCode.editOperatorProvider.loading;
      },
      stateEdit() {
        return this.$store.state.statusCode.editOperatorProvider.state;
      },
    },
    watch: {
      clearForm: function(val){
        if(val) {
          this.$refs.validator.reset();
          this.setFields();
        }
      },
      stateEdit: function(val){
        if (val == 200){
          this.$emit('successEdit');
        }
      },
    },
    created(){
      this.setFields();
    },
    methods:{
      submitDataForm(){
        let formSend = {
          operator: this.operator,
          provider: this.provider.p._id,
          data: {
            urls: {
              launcher: this.form.urls.launcher,
              bonusAward: this.form.urls.bonusAward,
              bonusCancel: this.form.urls.bonusCancel,
              ping: this.form.urls.ping,
              roundDetails: this.form.urls.roundDetails,
              fixedLauncher: this.form.urls.fixedLauncher,
              baseUrl: this.form.urls.baseUrl,
              gameList: this.form.urls.gameList,
            },
          }
        }
        if (this.form.key1 != ''){
          formSend.data.key1 = this.form.key1;
        }
        if (this.form.key2 != ''){
          formSend.data.key2 = this.form.key2;
        }
        if (this.form.key3 != ''){
          formSend.data.key3 = this.form.key3;
        }
        if (this.form.ggr != null){
          formSend.data.ggr = this.form.ggr;
        }
        if (this.form.cap != null){
          formSend.data.cap = this.form.cap;
        }
        if (this.form.params.length){
          formSend.data.params = {};
          this.form.params.forEach((item) => {
            formSend.data.params[item.key] = item.value;
          });
        }
        if (this.form.launcherParams.length){
          formSend.data.launcherParams = {};
          this.form.launcherParams.forEach((item) => {
            formSend.data.launcherParams[item.key] = item.value;
          });
        }
        if (this.form.cl){
          formSend.data.cl = {};
          formSend.data.cl.f = !!this.form.cl.f;
          formSend.data.cl.w = !!this.form.cl.w;
        }
        this.$store.dispatch('editOperatorProvider', formSend);
      },
      setFields(){
        this.form.key1 = this.provider.k1 != undefined ? this.provider.k1 : '';
        this.form.key2 = this.provider.k2 != undefined ? this.provider.k2 : '';
        this.form.key3 = this.provider.k3 != undefined ? this.provider.k3 : '';
        this.form.ggr = this.provider.ggr != undefined? this.provider.ggr.toString() : null;
        this.form.cap = this.provider.cap != undefined? this.provider.cap.toString() : null;
        this.form.urls.launcher = this.provider.urls != undefined ? this.provider.urls.l : '';
        this.form.urls.bonusAward = this.provider.urls != undefined ? this.provider.urls.ba : '';
        this.form.urls.bonusCancel = this.provider.urls != undefined ? this.provider.urls.bc : '';
        this.form.urls.ping = this.provider.urls != undefined ? this.provider.urls.p : '';
        this.form.urls.roundDetails = this.provider.urls != undefined ? this.provider.urls.rd : '';
        this.form.urls.fixedLauncher = this.provider.urls != undefined ? this.provider.urls.fl : '';
        this.form.urls.baseUrl = this.provider.urls != undefined ? this.provider.urls.bu : '';
        this.form.urls.gameList = this.provider.urls != undefined ? this.provider.urls.gl : '';
        this.form.params = this.changeObjectToArray(this.provider.params);
        this.form.launcherParams = this.changeObjectToArray(this.provider.lp);
        this.form.cl.f = this.provider.cl.f != undefined ? this.provider.cl.f : false;
        this.form.cl.w = this.provider.cl.w != undefined ? this.provider.cl.w : false;
      },
      changeObjectToArray(objarr){
        if(objarr != undefined){
          let arr = [];
          Object.keys(objarr).forEach(keyitem=>{
            arr.push({
              key: keyitem,
              value: objarr[keyitem]
            });
          })
          return arr;
        } else {
          return [];
        }
      },
    }
  }
</script>

<style lang="sass">
</style>